// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__iLE5f","disabled":"FileBtn_disabled__Is_la","warn":"FileBtn_warn__2FS9R","fade":"FileBtn_fade__1f6rR"};